<template>
  <div class="my-lessons">
    <div class="f_s_s f-d-c w-100">
      <h6>فعالیت هفتگی</h6>
      <breadcrumbs :breadcrumbsData="breadcrumbsData"></breadcrumbs>
    </div>
    <div class="divider"></div>
    <div class="calendarBox f_s_b col-12">
      <div
        v-if="!noActivities && !emptyActivitiesData"
        class="calendar col-8 p-0"
      >
        <div class="title f_c_b mb-3">
          <div class="month">{{ titleMonth }} {{ titleYear }}</div>
        </div>
        <div class="weekControlBtn f_c_b mb-3">
          <a title="هفته قبل" class="right" @click="prevWeek()"
            ><div class="activitiesArrow myright"></div
          ></a>
          <a title="هفته بعد" class="left" @click="nextWeek()"
            ><div class="activitiesArrow myleft"></div
          ></a>
        </div>
        <div class="content footer-activities f_s_s">
          <div class="week f_c_b">
            <div
              class="week-item f_c_c"
              v-for="(value, i) in currentWeek"
              :key="i"
              :class="[isactive == i ? 'activeDate' : '']"
              @click.prevent="dateClick(value, i)"
            >
              <div class="date">{{ value }}</div>
              <div class="day">{{ mobileWeek[i] }}</div>
            </div>
          </div>
          <div class="activities f_s_s pt-4">
            <div
              class="activitiesTabel f_c_c"
              v-if="activitiesList.length"
              :class="[dateActivities.length == 0 ? 'empty-box' : '']"
            >
              <div
                class="activitiesTabel-item f_c_b"
                v-for="(value, i) in dateActivities"
                :key="i"
              >
                <div class="activitiesName f_c_s pr-5">
                  <b-img
                    class="image"
                    :src="require(`@/assets/images/my/show/dots.svg`)"
                    fluid
                  ></b-img>
                  <a @click="findRout(value)" class="name">{{ value.name }}</a>
                </div>
                <div class="activitiesTime f_c_c">
                  <b-img
                    class="image"
                    :src="require(`@/assets/images/my/lessons/clock-gray.svg`)"
                    fluid
                  ></b-img>
                  <div class="time">{{ value.start }}-{{ value.end }}</div>
                </div>
              </div>
              <div
                class="emptyActivities f_c_c animate__animated animate__flash animate__delay-1s animate__repeat-3"
                v-if="dateActivities.length == 0"
              >
                فعالیتی وجود ندارد.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="emptyActivitiesData"
        class="emptyActivitiesData w-100 h-100 f_c_c f-d-c"
      >
        <div class="font-weight-bold fn-1-5rem c00aa82">
          هفته جاری خارج از بازه ترم می باشد.
        </div>
        <div
          v-if="nextPrevWeek.termStartDate && nextPrevWeek.termEndDate"
          class="fn-09rem c00aa82 mb-3"
        >
          (
          {{
            nextPrevWeek.termStartDate.split("-")[0] +
            "/" +
            nextPrevWeek.termStartDate.split("-")[1] +
            "/" +
            nextPrevWeek.termStartDate.split("-")[2]
          }}
          تا
          {{
            nextPrevWeek.termEndDate.split("-")[0] +
            "/" +
            nextPrevWeek.termEndDate.split("-")[1] +
            "/" +
            nextPrevWeek.termEndDate.split("-")[2]
          }}
          )
        </div>
        <div class="fn-1rem c00aa82">
          برای مشاهده تمام فعالیت ها از اول ترم کلیک کنید.
        </div>
        <div
          class="fn-09rem showAllActivitiesBtn"
          @click.prevent="showAllActivitiesFunc()"
        >
          مشاهده فعالیت ها
        </div>
      </div>
      <div v-if="!noActivities" class="task-class col-3 p-0 f_c_sa">
        <b-img
          class="lesson-class-icon"
          :src="require(`@/assets/images/my/show/showIcon.svg`)"
          fluid
        ></b-img>
      </div>
      <div class="spinner f_c_c" v-if="noActivities">
        <b-spinner type="grow" variant="info" label="Loading..."></b-spinner>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import breadcrumbs from "@/components/Breadcrumbs";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "Activities",
  data() {
    return {
      activeDate: "activeDate",
      isactive: null,
      noActivities: false,
      currentDate: null,
      selectDate: null,
      mobileWeek: ["ش", "ی", "د", "س", "چ", "پ", "ج"],
      activitiesList: [],
      dateActivities: [],
      breadcrumbsData: [
        {
          title: "فعالیت هفتگی من",
          path: "",
        },
      ],
      currentWeek: [],
      firstDay: null,
      titleMonth: null,
      titleYear: null,
      nextOrPrev: false,
      emptyActivitiesData: false,
      selectExam: {},
    };
  },
  created() {},
  computed: {
    ...mapState({
      loginStates: (state) => state.login,
      heightWidthValue: (state) => state.login.heightWidthValue,
      LessonsDays: (state) => state.my.lessonDays,
      Activities: (state) => state.my.activities,
      nextPrevWeek: (state) => state.my.nextPrevWeek,
      time: (state) => state.my.time,
    }),
    user() {
      return this.loginStates.user;
    },
  },
  components: { breadcrumbs },
  props: {},
  methods: {
    ...mapActions("my", [
      "prevUrlFunction",
      "emptyActivitiesFunction",
      "setActivitiesLinkFunction",
      "getWeekActivitiesFunction",
      "getWeekNextPrevFunction",
      "getTimeFunction",
      "weeklyLessonFunction",
      "setBreadcrumbsPathFunction",
    ]),
    prevWeek() {
      if (this.nextPrevWeek.prevWeekStartDate == -1) {
        this.$bvToast.toast("هفته قبلی وجود ندارد.", {
          title: "خطا در اتصال",
          variant: "danger",
          solid: true,
        });
      } else {
        this.nextOrPrev = true;
        this.noActivities = true;
        this.currentWeek = [];
        this.isactive = null;
        this.firstDay = this.nextPrevWeek.prevWeekStartDate;
        this.getWeekActivitiesFunction({
          wstoken: this.user.token,
          firstDay: this.nextPrevWeek.prevWeekStartDate,
        });
      }
    },
    nextWeek() {
      if (this.nextPrevWeek.nextWeekStartDate == -1) {
        this.$bvToast.toast("هفته بعدی وجود ندارد.", {
          title: "خطا در اتصال",
          variant: "danger",
          solid: true,
        });
      } else {
        this.nextOrPrev = true;
        this.noActivities = true;
        this.currentWeek = [];
        this.isactive = null;
        this.firstDay = this.nextPrevWeek.nextWeekStartDate;
        this.getWeekActivitiesFunction({
          wstoken: this.user.token,
          firstDay: this.nextPrevWeek.nextWeekStartDate,
        });
      }
    },
    showAllActivitiesFunc() {
      this.getWeekActivitiesFunction({
        wstoken: this.user.token,
        firstDay: this.nextPrevWeek.termStartDate,
      });
    },
    findRout(rout) {
      if (rout.mod == "quiz") {
        let id = this.LessonsDays.week.indexOf(this.LessonsDays.currentDay);
        let selectDay = parseInt(this.convertDigit("en", this.selectDate));
        let selectMonth = parseInt(this.monthCode("code", this.titleMonth));
        let selectYear = parseInt(this.toEnNumber(this.titleYear));
        let currentDay = parseInt(
          this.convertDigit("en", this.LessonsDays.currentDay)
        );
        let currentMonth = parseInt(
          this.LessonsDays.monthList.length > 0
            ? this.monthCode("code", this.LessonsDays.monthList[id])
            : this.monthCode("code", this.LessonsDays.month)
        );
        let currentYear = parseInt(this.toEnNumber(this.LessonsDays.year));
        rout.date = selectYear + "-" + selectMonth + "-" + selectDay;
        if (
          selectDay == currentDay &&
          selectMonth == currentMonth &&
          selectYear == currentYear
        ) {
          this.getTimeFunction({ wstoken: this.user.token });
          this.selectExam = rout;
        } else {
          this.$bvToast.toast("تاریخ آزمون مربوط به روز جاری نمی باشد.", {
            title: "اتمام وقت آزمون",
            variant: "danger",
            solid: true,
          });
        }
      } else if (rout.mod == "assign") {
        rout.date =
          this.toEnNumber(this.titleYear) +
          "-" +
          this.monthCode("code", this.titleMonth) +
          "-" +
          this.convertDigit("en", this.selectDate);
        this.setActivitiesLinkFunction({
          id: parseInt(rout.id),
          data: rout,
          month: this.LessonsDays.month,
        });
        this.$router.push({ name: "tasks" });
      } else {
        let id = parseInt(rout.courseid);
        let name = rout.name.replace("کلاس", "").trim();
        this.weeklyLessonFunction({
          wstoken: this.user.token,
          date: this.activitiesList[this.isactive].date,
        });
        this.setActivitiesLinkFunction({
          id: this.LessonsDays.week[parseInt(this.isactive)],
          day: document.querySelector(".activeDate .date").innerText,
          data: { id: id, displayname: name },
          month: this.titleMonth,
        });
        this.setBreadcrumbsPathFunction({
          parent: "activities",
          paths: [
            {
              title: "فعالیت هفتگی من",
              path: "activities",
            },
            {
              title: "کلاس های آنلاین",
              path: "",
            },
          ],
        });
        this.$router.push({ name: "onlineclass" });
      }
    },
    dateClick(value, i) {
      this.selectDate = value;
      this.dateActivities = [];
      this.isactive = i;
      let day = this.convertDigit("en", value);
      this.getDateActivities(day, i);
      if (this.nextOrPrev) {
        let mon = this.activitiesList[i].date.split("-")[1];
        this.titleMonth = this.monthCode("month", mon);
      } else {
        if (this.LessonsDays.monthList.length) {
          this.titleMonth = this.LessonsDays.monthList[i];
        } else {
          this.titleMonth = this.LessonsDays.month;
        }
      }
    },
    getDateActivities(day, i) {
      if (this.nextOrPrev) {
        let month = this.Activities[i].date.split("-")[1];
        let year = this.Activities[i].date.split("-")[0];
        for (let i = 0; i < this.activitiesList.length; i++) {
          let date = this.activitiesList[i].date.split("-");
          if (date[0] == year && date[1] == month && date[2] == day) {
            this.dateActivities = this.activitiesList[i].activities;
          }
        }
      } else {
        let month = this.LessonsDays.monthList.length
          ? this.monthCode("code", this.LessonsDays.monthList[i])
          : this.monthCode("code", this.LessonsDays.month);
        let year = this.toEnNumber(this.LessonsDays.year);

        for (let i = 0; i < this.activitiesList.length; i++) {
          let date = this.activitiesList[i].date.split("-");
          if (date[0] == year && date[1] == month && date[2] == day) {
            this.dateActivities = this.activitiesList[i].activities;
          }
        }
      }
    },
    getWeekSelectDay(n) {
      this.titleMonth = n.month;
      this.titleYear = n.year;
      this.currentWeek = n.week;
      this.selectDate = n.currentDay;
      this.currentDate = n.currentDay;
      let id = n.week.indexOf(n.currentDay);
      this.isactive = id;
      // setTimeout(() => {
      //   this.currentWeek =  this.Activities
      // }, 1000);
    },
  },
  watch: {
    time: function (n) {
      if (Object.keys(this.selectExam).length) {
        let currentHour = parseInt(n[0].time.split(":")[0]);
        let currentMinute = parseInt(n[0].time.split(":")[1]);
        let startHour = parseInt(this.selectExam.start.split(":")[0]);
        let startMinute = parseInt(this.selectExam.start.split(":")[1]);
        let endHour = parseInt(this.selectExam.end.split(":")[0]);
        let endMinute = parseInt(this.selectExam.end.split(":")[1]);
        if (
          (startHour < currentHour || startHour == currentHour) &&
          currentHour < endHour
        ) {
          this.setActivitiesLinkFunction({
            id: parseInt(this.selectExam.id),
            data: this.selectExam,
            month: this.LessonsDays.month,
          });
          this.$router.push({ name: "exam" });
        } else if (startHour < currentHour && currentHour == endHour) {
          if (currentMinute < endMinute) {
            this.setActivitiesLinkFunction({
              id: parseInt(this.selectExam.id),
              data: this.selectExam,
              month: this.LessonsDays.month,
            });
            this.$router.push({ name: "exam" });
          } else {
            this.$bvToast.toast("زمان آزمون به پایان رسیده است.", {
              title: "اتمام وقت آزمون",
              variant: "danger",
              solid: true,
            });
          }
        } else if (startHour == currentHour && currentHour == endHour) {
          if (startMinute < currentMinute && currentMinute < endMinute) {
            this.setActivitiesLinkFunction({
              id: parseInt(this.selectExam.id),
              data: this.selectExam,
              month: this.LessonsDays.month,
            });
            this.$router.push({ name: "exam" });
          } else {
            this.$bvToast.toast("آزمون در بازه زمانی مورد نظر نمی باشد.", {
              title: "اتمام وقت آزمون",
              variant: "danger",
              solid: true,
            });
          }
        } else {
          this.$bvToast.toast("آزمون در بازه زمانی مورد نظر نمی باشد.", {
            title: "اتمام وقت آزمون",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    Activities: function (n) {
      if (n.length) {
        this.emptyActivitiesData = false;
        this.noActivities = false;
        let index = this.LessonsDays.week.indexOf(n.currentDay);
        let day = parseInt(
          this.convertDigit("en", this.LessonsDays.currentDay)
        );
        let month = parseInt(
          this.LessonsDays.length
            ? this.monthCode("code", this.LessonsDays.monthList[index])
            : this.monthCode("code", this.LessonsDays.month)
        );
        let year = parseInt(this.toEnNumber(this.LessonsDays.year));
        this.activitiesList = n;
        if (this.nextOrPrev) {
          let id = 0;
          for (let i = 0; i < n.length; i++) {
            let dayWeek = parseInt(n[i].date.split("-")[2]);
            let monthWeek = parseInt(n[i].date.split("-")[1]);
            let yearWeek = parseInt(n[i].date.split("-")[0]);
            this.currentWeek.push(this.convertDigit("fa", dayWeek));
            if (dayWeek == day && monthWeek == month && yearWeek == year) {
              id = this.LessonsDays.week.indexOf(this.LessonsDays.currentDay);
              day = dayWeek;
            }
          }
          if (id) {
            this.getDateActivities(day, id);
          } else {
            this.getDateActivities(
              this.convertDigit("en", this.currentWeek[0]),
              id
            );
          }
          this.isactive = id;
          let mon = this.activitiesList[id].date.split("-")[1];
          this.titleMonth = this.monthCode("month", mon);
          this.getWeekNextPrevFunction({
            wstoken: this.user.token,
            firstDay: this.firstDay,
          });
        } else {
          let id = this.LessonsDays.week.indexOf(this.LessonsDays.currentDay);
          this.getDateActivities(day, id);
          this.getWeekNextPrevFunction({
            wstoken: this.user.token,
            firstDay: this.firstDay,
          });
        }
      } else {
        this.emptyActivitiesData = true;
        this.currentWeek = [];
        this.firstDay = this.nextPrevWeek.termStartDate;
        this.nextOrPrev = true;
        this.getWeekNextPrevFunction({
          wstoken: this.user.token,
          firstDay: this.nextPrevWeek.termStartDate,
        });
      }
    },
    nextPrevWeek: function () {},
  },
  mounted() {
    this.setHeight(this.heightWidthValue);
    this.getWeekSelectDay(this.LessonsDays);
    let year = this.toEnNumber(this.LessonsDays.year);
    let month = this.LessonsDays.monthList.length
      ? this.monthCode("code", this.LessonsDays.monthList[0])
      : this.monthCode("code", this.LessonsDays.month);
    let day = this.LessonsDays.weekDigitEn[0];
    this.firstDay = year + "-" + month + "-" + day;
    this.getWeekActivitiesFunction({
      wstoken: this.user.token,
      firstDay: year + "-" + month + "-" + day,
    });
  },
  beforeDestroy: function () {
    this.prevUrlFunction("activities");
    this.emptyActivitiesFunction([]);
  },
};
</script>
<style lang="scss" scoped>
.my-lessons {
  height: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 0.2rem 1rem;
  h6 {
    padding: 10px 10px 0 0;
    margin: 0;
  }
  .calendarBox {
    padding: 0 10px;
    height: 100%;
    .emptyActivitiesData {
      .showAllActivitiesBtn {
        padding: 5px 10px;
        cursor: pointer;
        margin-top: 10px;
        color: #1d9dae;
        border: 1px solid #1d9dae;
        border-radius: 10px;
      }
    }
    .calendar {
      flex: 0 0 72.333333% !important;
      max-width: 72.666667%;
      height: 95%;
      .title {
        .lesson-name {
          color: #1d9dae;
          font-size: 18px;
          font-weight: bold;
        }
        .month {
          color: #006e7f;
          font-size: 16px;
        }
      }
      .weekControlBtn {
        width: 100%;
        .left,
        .right {
          padding: 4px 10px 2px 10px;
          border: 1px solid #1d9dae;
          border-radius: 5px;
          cursor: pointer;
        }
      }
      .content {
        flex-direction: column;
        width: 100%;
        height: 70%;
        overflow: auto;
        .week {
          width: 100%;
          .week-item {
            width: 13%;
            flex-direction: column;
            border-radius: 10px 10px 0 0;
            background-color: #006e7f;
            color: white;
            cursor: pointer;
          }
          .activeDate {
            background-color: #f5f4f4;
            color: #006e7f;
          }
        }
        .activities {
          width: 100%;
          background-color: #f5f4f4;
          border-radius: 0 0 10px 10px;
          padding-bottom: 10px;
          flex-direction: column;
          .activitiesTabel {
            width: 90%;
            flex-direction: column;
            margin: 0 auto;
            margin-bottom: 0.5rem;
            border: 1px solid #1d9dae;
            .activitiesTabel-item {
              width: 100%;
              padding: 2% 0;
              border-bottom: 1px solid #1d9dae;
              &:last-child {
                border-bottom: none;
              }
              .activitiesName {
                width: 68%;
                .image {
                  margin-left: 10px;
                }
                .name {
                  font-size: 13px;
                  color: #1d9dae;
                  width: 95%;
                  cursor: pointer;
                  word-wrap: break-word;
                }
              }
              .activitiesTime {
                width: 30%;
                .image {
                  width: 14px;
                  margin-left: 5px;
                }
                .time {
                  font-size: 13px;
                  color: #a2a2a2;
                }
              }
            }
            .emptyActivities {
              height: 15vh;
              font-size: 20px;
              font-weight: bold;
              color: #4bddb1;
            }
          }
          .empty-box {
            height: inherit;
          }
        }
      }
    }
    .task-class {
      position: relative;
      padding: 0 10px;
      height: 100%;
      flex-direction: column;
      .lesson-class-icon {
        width: 200px;
      }
    }
    .spinner {
      width: 100%;
      height: 47vh;
    }
  }
}
@media (max-height: 650px), (max-width: 1200px) {
  .my-lessons {
    padding: 0;
    .calendarBox {
      flex-direction: column;
      padding: 0 10px;
      .calendar {
        flex: 0 0 100% !important;
        max-width: 100%;
        .content {
          justify-content: flex-start;
          .activities {
            .activitiesTabel {
              .activitiesTabel-item {
                .activitiesName {
                  padding-right: 10px !important;
                }
              }
            }
          }
        }
      }
      .task-class {
        display: none;
      }
      .spinner {
        height: 66vh;
      }
    }
  }
}
@media (max-width: 767px) {
  .my-lessons {
    padding: 0;
    .calendarBox {
      flex-direction: column;
      padding: 0 10px;
      .calendar {
        flex: 0 0 100% !important;
        max-width: 100%;
        .content {
          height: 85%;
          justify-content: flex-start;
          .activities {
            .activitiesTabel {
              .activitiesTabel-item {
                .activitiesName {
                  padding-right: 10px !important;
                }
              }
            }
          }
        }
      }
      .task-class {
        display: none;
      }
      .spinner {
        height: 66vh;
      }
    }
  }
}
@media (max-height: 680px) {
  .my-lessons {
    .calendarBox {
      .calendar {
        height: 85%;
      }
    }
  }
}
</style>